export const fwVersionsChartChargersTableID = 'fw_versions_chargers';

export const ViewModes = {
  list: 'list',
  graph: 'graph',
  empty: 'empty',
};

export const reportFilterForm = 'reportFilterForm';
